import React, { useMemo } from 'react';
import Table from '../../molecules/tablas/view';
import ButtonAction from '../../atoms/buttonAction/view';
import { BiTrash, BiCheckCircle, BiErrorCircle, BiLoaderAlt, BiShow } from 'react-icons/bi';
import './style.css';

const CargaMasivaTable = ({ data, onRemove, onView }) => {

    const tableData = useMemo(() => data.map(item => {
        // Find if any line has a third party object
        const lineWithThird = item.lineas.find(l => l.tercero_object);
        let terceroDisplay = "-";

        // Check for specific third party not found errors
        const thirdError = item.validation_errors.find(e => e.toLowerCase().includes('tercero') && e.toLowerCase().includes('no encontrado'));

        if (thirdError) {
            terceroDisplay = thirdError; // We will format it red in the table formats
        } else if (lineWithThird && lineWithThird.tercero_object) {
            const t = lineWithThird.tercero_object;
            terceroDisplay = t.business_name || t.name || t.identification || "-";
        }

        return {
            id: item.id,
            archivo: item.file_name,
            descripcion: item.cabecera.descripcion,
            tercero: terceroDisplay,
            debito: item.total_debito,
            credito: item.total_credito,
            estado: item.status,
            valido: item.isValid
        };
    }), [data]);

    const tableFormats = useMemo(() => ({
        debito: { type: "money" },
        credito: { type: "money" },
        tercero: {
            type: "custom",
            children: (item) => {
                if (typeof item.tercero === 'string' && item.tercero.toLowerCase().includes('no encontrado')) {
                    return <span className="text-danger fw-bold small">{item.tercero}</span>;
                }
                return <span className="text-truncate d-inline-block" style={{ maxWidth: '150px' }} title={item.tercero}>{item.tercero}</span>;
            }
        },
        estado: {
            type: "custom",
            children: (item) => {
                if (item.estado === 'loading') return <BiLoaderAlt className="spinner-animation text-primary" size={20} />;
                if (item.estado === 'success') return <BiCheckCircle className="text-success" size={20} title="Cargado con éxito" />;
                if (item.estado === 'error') return <BiErrorCircle className="text-danger" size={20} title="Error al cargar" />;

                if (!item.valido) return <BiErrorCircle className="text-warning" size={20} title="Formato inválido" />;
                return <BiCheckCircle className="text-secondary" size={20} title="Pendiente" />;
            }
        },
        archivo: {
            type: "custom",
            children: (item) => (
                <div className="file-info-cell">
                    <span className="file-name-text">{item.archivo}</span>
                    {!item.valido && (
                        <small className="validation-error-text">
                            {data.find(d => d.id === item.id)?.validation_errors.join(", ")}
                        </small>
                    )}
                    {item.estado === 'error' && (
                        <small className="validation-error-text">
                            {data.find(d => d.id === item.id)?.error_message}
                        </small>
                    )}
                </div>
            )
        }
    }), [data]);

    return (
        <div className="carga-masiva-table-container">
            <Table
                showSkeleton={false}
                emptyMessage="No se han cargado archivos aún."
                maxHeight='100%'
                headersList={["Archivo", "Descripción", "Tercero", "Débito", "Crédito", "Status"]}
                data={tableData}
                excludeList={["id", "valido"]}
                formats={tableFormats}
                allowSearch={false}
            >
                <ButtonAction
                    onClick={(item) => onView(item.id)}
                    title={<BiShow size={18} />}
                    className="btn-view-row text-primary bg-primary-light"
                />
                <ButtonAction
                    onClick={(item) => onRemove(item.id)}
                    title={<BiTrash size={18} />}
                />
            </Table>
        </div>
    );
};

export default CargaMasivaTable;
